<template>
  <div class="delivery-page">
    <h1 class="bigshot">{{ $t('W2P_DELIVERY_TITLE') }}</h1>
    <p class="subheader-text">
      {{ $t('W2P_DELIVERY_CHOOSE') }}
      <span v-if="haveInternationalAddresses" class="bold">
        {{ $t('W2P_DELIVERY_NOTE') }}
      </span>
      {{ $t('W2P_INTERNATIONAL_DELIVERIES_INFO') }}
    </p>

    <preset-delivery></preset-delivery>

    <div class="button-container">
      <pn-button-container size="medium" secondary>
        <button type="button" @click="back">
          {{ $t('W2P_LETTER_BACK') }}
        </button>
      </pn-button-container>
      <pn-button-container size="medium">
        <button :disabled="invalidOption" @click="next">
          {{ $t('NEXT') }}
        </button>
      </pn-button-container>
    </div>
  </div>
</template>

<script>
import PresetDelivery from '@/components/letter/delivery/PresetDeliveryComponent.vue'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('letter/delivery', ['deliveryDate', 'deliveryId']),
    ...mapState('letter/address', ['recipientsData', 'selectedAddressOption']),
    invalidOption() {
      return (
        !this.deliveryDate ||
        !this.deliveryDate.length ||
        !this.deliveryId ||
        !this.deliveryId.length
      )
    },
    haveInternationalAddresses() {
      if (
        this.recipientsData[1] ||
        this.recipientsData[2] ||
        this.recipientsData[3]
      ) {
        return true
      }
      return false
    }
  },
  components: {
    PresetDelivery
  },
  methods: {
    back() {
      this.$router.push({ name: this.selectedAddressOption })
    },
    next() {
      this.$router.push({ name: 'pay' })
    }
  },
  mounted() {
    sessionStorage.removeItem('orderPlaced')
  }
}
</script>

<style lang="scss">
.delivery-page {
  .subheader-text {
    color: $gray700;
    margin-top: 0.5em;
    margin-bottom: 1.5em;
  }
  .bold {
    font-weight: 900;
  }
}

@media screen and (max-width: 50em) {
  .delivery-page {
    padding: 0;
  }
}
</style>
